module.exports = __webpack_public_path__ + "static/home-a4cc43029beaa7172adfe82b48ab9b2c.mp4";